// FNP-58: form-shape Zod schema (replaces the prior Yup parallel schema). The
// fuller domain `ActivityLogSchema` in `../schemas/index.ts` validates
// server-returned records (requires `id` as uuid); this schema validates the
// in-flight form values which start without an `id` on Add.
import {z} from 'zod';

export const RecordSchema = z.object({
    username: z.string().min(1, 'Required'),
    usageType: z.string().min(1, 'Required'),
    value: z.number({invalid_type_error: 'Required'}),
    action: z.string().min(1, 'Required'),
    recordId: z.string().min(1, 'Required'),
    created: z.string().min(1, 'Required'),
});
